import $ from 'jquery';
import enquire from 'enquire.js';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'flickity-imagesloaded';
import isInViewport from '../modules/isInViewport.js';
import throttle from '../modules/throttle.js';
import * as focusTrap from 'focus-trap';
import userPrefersReducedMotion from '../modules/userPrefersReducedMotion';

Flickity.setJQuery($);
jQueryBridget('flickity', Flickity, $);

const HomeRoute = () => {

  //
  //   Slideshows
  //
  //////////////////////////////////////////////////////////////////////

  //   Features
  //--------------------------------------------------------------------
  const $featureSlideshowBtns = $('.js-slider-btn');
  const $featureSlideshow = $('.js-feature-slideshow');
  const featuredSlideSelector = '.js-feature-slideshow-slide';
  const isSelectedClass = 'is-selected';
  const visuallyHiddenSelector = ('.h-hide-visually');

  const disableLinksInInactiveSlides = (flickityObj) => {
    $(flickityObj.slider).find('[aria-hidden="true"] a[href]').attr('tabindex', '-1');
  };

  const enableLinksInsideActiveSlides = (flickityObj) => {
    $(flickityObj.selectedElement).find('a[href]').removeAttr('tabindex');
  }

  const getVisuallyHiddenSpan = (btn) => {
    return $(btn).find(visuallyHiddenSelector);
  };

  const clearVisuallyHiddenBtnText = () => {
    $featureSlideshowBtns.each((i, button) => {
      const $srOnlySpan = getVisuallyHiddenSpan(button);
      if ($srOnlySpan.length) {
        $srOnlySpan.text('');
      }
    });
  };

  const markButtonAsActive = (btn) => {
    const $srOnlySpan = getVisuallyHiddenSpan(btn);
    if ($srOnlySpan) {
      $srOnlySpan.text(' (Current Slide)');
    }
  };

  const getButtonBySlideIndex = (index) => {
    return $featureSlideshowBtns.filter(`[data-connects-with="${index}"]`);
  };


  const activateSlideByButton = (btn) => {
    const connectsWith = $(btn).attr('data-connects-with');
    $featureSlideshow.flickity().flickity('select', connectsWith);
  };

  // init Flickity
  $featureSlideshow.flickity({
    cellSelector: featuredSlideSelector,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    draggable: true,
    selectedAttraction: 0.08,
    friction: 0.5,
    imagesLoaded: true,
    on: {
      change: function(index) {
        $featureSlideshowBtns.removeClass(isSelectedClass);
        $featureSlideshowBtns.filter(function() {
          return $(this).attr('data-connects-with') == index;
        }).addClass(isSelectedClass);

        // Reset visually-hidden text for all buttons
        clearVisuallyHiddenBtnText();

        // Add visually-hidden text to the active button
        const $activeButton = getButtonBySlideIndex(index);
        if ($activeButton.length) {
          markButtonAsActive($activeButton);
        }

        disableLinksInInactiveSlides(this);
        enableLinksInsideActiveSlides(this);
      },
      ready: function() {
        disableLinksInInactiveSlides(this);
        enableLinksInsideActiveSlides(this);
        // Mark first slide button as active
        markButtonAsActive($featureSlideshowBtns.first());
      }
    }
  });

  // Connecting to Buttons
  $featureSlideshowBtns.bind('click', function() {
    activateSlideByButton($(this));
  });

  $featureSlideshowBtns.bind('keydown', function(event) {
    const shouldActivate = event.key === 'Enter' || event.key === ' ';

    if (!shouldActivate) return;

    event.preventDefault();
    activateSlideByButton($(this));
  });

  // Select slides when clicked on
  $featureSlideshow.on('staticClick.flickity', function(ev) {
    let $slide = $(ev.originalEvent.srcElement);
    if (!$slide.is(featuredSlideSelector)) {
      $slide = $slide.closest(featuredSlideSelector);
      if (!$slide.length) {
        return;
      }
    }
    $featureSlideshow.flickity('select', $slide.attr('data-index'));
  });


  //   In the Field
  //--------------------------------------------------------------------
  const initGallery = ($mockupSlideshow) => {
    const mockupSlideSelector = '.js-mockup-gallery-slide';

    // init Flickity
    $mockupSlideshow.flickity({
      cellSelector: mockupSlideSelector,
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
      draggable: true,
      selectedAttraction: 0.08,
      imagesLoaded: true,
      friction: 0.5
    });
  
    // Select slides when clicked on
    $mockupSlideshow.on('staticClick.flickity', function(ev) {
      let $slide = $(ev.originalEvent.srcElement);
      if (!$slide.is(mockupSlideSelector)) {
        $slide = $slide.closest(mockupSlideSelector);
        if (!$slide.length) {
          return;
        }
      }
      $mockupSlideshow.flickity('select', $slide.attr('data-index'));
    });
  }

  const $mockupSlideshow = $('.js-mockup-gallery');
  initGallery($mockupSlideshow);
  

  //   Feature Overview
  //--------------------------------------------------------------------
  const $featureOverview = $('.js-feature-overview');
  const slideshowBreakpoint = 'screen and (max-width: 879px)';

  $featureOverview.flickity({
    cellSelector: '.js-feature-overview-item',
    wrapAround: true,
    pageDots: true,
    prevNextButtons: false,
    draggable: true,
    watchCSS: true,
    selectedAttraction: 0.08,
    friction: 0.5
  });

  //   Projects Gallery Lite
  //--------------------------------------------------------------------
  const $projectsGalleryLite = $('.js-projects-gallery-lite');
  const $projectsGalleryLiteCarousel = $('.js-projects-gallery-lite-carousel');
  const $skipLink = $('.js-projects-gallery-lite-skip-link');
  const $toggleButton = $projectsGalleryLite.find('[data-toggle-button]');

  // Update skip link target based on layout
  const $thisSection = $skipLink.closest('.l-section');
  const $nextSection = $thisSection.next() ? $thisSection.next() : $('.site-footer');
  let targetId;

  if ($nextSection.length) {
    targetId = $nextSection.attr('id');

    if (!targetId) {
      targetId = `section-${Math.floor(Math.random() * 1000000)}`;
      $nextSection.attr('id', targetId);
    }

    $skipLink.attr('href', `#${targetId}`);
    $nextSection.attr('tabindex', '-1');
  }

  const carousels = [];

  $projectsGalleryLiteCarousel.each((index) => {
    const $row = $($projectsGalleryLiteCarousel[index])
    const rowReverse = index % 2 != 0
    const cellSelector = '.js-projects-gallery-lite-slide'

    $row.flickity({
      cellSelector: cellSelector,
      autoPlay: false,
      rightToLeft: rowReverse,

      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      draggable: true,
      selectedAttraction: 0.08,
      friction: 0.5,
      imagesLoaded: true,
      cellAlign: rowReverse ? 'right' : 'left',
      contain: true,
      on: {
        ready: function() {
          disableLinksInInactiveSlides(this);
          enableLinksInsideActiveSlides(this);
        },
        change: function() {
          disableLinksInInactiveSlides(this);
          enableLinksInsideActiveSlides(this);
        },
      }
    });

    carousels.push($row)

  })

  const playCarousels = () => {
    carousels.forEach(($carousel) => {
      if ($carousel && typeof $carousel.flickity === 'function') {
        $carousel.flickity('playPlayer')
      }
    })
  };

  const pauseCarousels = () => {
    carousels.forEach(($carousel) => {
      if ($carousel && typeof $carousel.flickity === 'function') {
        $carousel.flickity('pausePlayer')
      }
    })
  };

  // Set initial state based on user preference
  if (!userPrefersReducedMotion()) {
    setTimeout(() => {
      playCarousels();
    }, 1000)
    $toggleButton.find('[data-icon="play"]').hide();
    $toggleButton.attr('data-state', 'playing');
  } else {
    $toggleButton.find('[data-icon="pause"]').hide();
    $toggleButton.attr('data-state', 'paused');
  }


  // Toggle button functionality
  $toggleButton.on('click', function() {
    const buttonState = $(this).attr('data-state');
    const $icons = $(this).find('[data-icon]');
    $icons.hide();

    if (buttonState == 'playing') {
      pauseCarousels();
      $(this).find('[data-icon="play"]').show();
      $(this).attr('data-state', 'paused');
    } else if (buttonState == 'paused') {
      playCarousels();
      $(this).find('[data-icon="pause"]').show();
      $(this).attr('data-state', 'playing');
    }
  });

};

export default HomeRoute;
